import { isNil, isNumber } from "lodash";
export var adjustPrecision = function (_a, digits) {
    var lat = _a.lat, lng = _a.lng;
    if (digits === void 0) { digits = 6; }
    if (isNil(lat) || isNil(lng)) {
        return null;
    }
    return {
        lat: Number(lat.toFixed(digits)),
        lng: Number(lng.toFixed(digits))
    };
};
export var hasValidValues = function (lat, lng) { return isNumber(lat) && isNumber(lng); };
